module.exports = __webpack_public_path__ + "static/media/Knigh390_2c.d4cbee1d.svg";